import { ATBaseClient } from '@src/services/ATBaseClient';

const atBaseClient = new ATBaseClient();

/**
 * Client for making cross frame calls to printingService in Seaward.
 */
export class PrintingService {
    /**
     * Calls hello world the provided config.
     *
     * @param {object} The config object to send.
     * @return {Promise} The promise resolves when the plugin returns hello world
     */
    public static helloWorld(config: any) {
        return PrintingService.makeATBaseCall('helloWorld', config);
    }

    /**
     * Calls pair device with the provided config.
     *
     * @param {object} The config object to send.
     * @return {Promise} The promise resolves when the device gets paired and
     *  rejects if there's an error.
     */
    public static pair(config: any) {
        return PrintingService.makeATBaseCall('pair', config);
    }

    /**
     * Calls print with the provided config.
     *
     * @param {object} The config object to send.
     * @param {object} extraOptions - Allows to pass extra options to the atBaseClient call
     *  Example:
     *      {
     *          sensitive: {boolean} // true if the data is sensitive so it doesn't get logged
     *      }
     * @return {Promise} The promise resolves when the printer receive the job and
     *  rejects if there's an error.
     */
    public static print(config: any, extraOptions?: any) {
        return PrintingService.makeATBaseCall('print', config, extraOptions);
    }

    /**
     * Makes the cross frame call to Seaward.
     */
    private static makeATBaseCall(action: any, parameters: any, extraOptions?: any) {
        return atBaseClient.call('printingListener', action, parameters, extraOptions);
    }
}
